module.exports = __webpack_public_path__ + "f87e48b7ace8704f82935e1993a33146.png";